import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { initialPartyForm } from '../../Data/Constants'
import { addParty } from '../../firebase-services/db-services'
import { getPartiesFetch } from '../../Redux/slices/partyState'
import handleChange from '../../Utils/HandleChange'
import { FormInput, FormRow } from '../Controls/Input'
import {  toast } from 'react-toastify';

export default function AddParty() {
  const dispatch = useDispatch()
    const [form, setForm] = useState(initialPartyForm)
    const changeHandler = handleChange(form, setForm)
    const submitHandler = (e) => {
        e.preventDefault()
        addParty(form).then(res=>{
            dispatch(getPartiesFetch())
            toast.success("New Party Added Successfully")
            //ScrollToTargetAdjusted('transactionTable')
          }).catch(e=>{
            toast.error("Failed to add New Party")
            console.log(e)
          })
        
    }
  return (
    <div id='addPartyForm' className="bg-gray-100 p-8 rounded-md mx-auto my-36 w-full max-w-7xl">
    <form className='w-full'>
      <h1 className='text-2xl sm:text-3xl md:text-4xl font-bold tracking-wide mb-7'>Add New Party</h1>
      <FormRow mx={3}>
        <FormInput name='name' type="text" label='Party Name' onChange={changeHandler} placeholder={"Party Name"} />
        <FormInput name='firm' type='text' label='Firm Name' placeholder='Party Firm Name' onChange={changeHandler} />
      </FormRow>
      <FormRow mx={3}>
        <FormInput name='mobile' type='text' label='Mobile No.' placeholder='9756721202' onChange={changeHandler} />
        <FormInput name='address' label='Address' onChange={changeHandler} placeholder="Party Address" />
      </FormRow>

      <div className='flex flex-row gap-4'>
        <button
          className="hover:bg-[#4f48ee] rounded-md bg-[#6A64F1] py-3 px-8 text-center text-base font-semibold text-white outline-none"
          onClick={submitHandler}
        >
          Submit
        </button>
        <input type="reset"
          className="hover:bg-gray-600 cursor-pointer rounded-md bg-gray-500 py-3 px-8 text-center text-base font-semibold text-white outline-none"
        />
      </div>
    </form>
  </div>
  )
}
